module.exports = require("./pt-ST.d.ts");